var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function isPlainObject(v) {
    return v !== null && typeof v === "object" && !Array.isArray(v);
}
function deepMerge(base, extra) {
    if (Array.isArray(base) && Array.isArray(extra)) {
        return __spreadArray(__spreadArray([], base, true), extra, true);
    }
    if (isPlainObject(base) && isPlainObject(extra)) {
        var out = __assign({}, base);
        for (var _i = 0, _a = Object.keys(extra); _i < _a.length; _i++) {
            var k = _a[_i];
            out[k] = k in base ? deepMerge(base[k], extra[k]) : extra[k];
        }
        return out;
    }
    return extra;
}
function extractKeyFromApiName(apiName) {
    var re = /\/V\d+\/([^/?#]+)/i;
    var match = apiName.match(re);
    if (!match || !match[1]) {
        throw new Error("No se pudo extraer la clave desde apiName: ".concat(apiName));
    }
    return decodeURIComponent(match[1]);
}
export function updateStepInLocalStorage(identifier, responses, storageKey) {
    if (storageKey === void 0) { storageKey = "steps"; }
    var raw = localStorage.getItem(storageKey);
    if (!raw) {
        throw new Error("No se encontr\u00F3 ".concat(storageKey, " en localStorage"));
    }
    var steps;
    try {
        steps = JSON.parse(raw);
    }
    catch (_a) {
        throw new Error("El contenido de localStorage no es un JSON válido");
    }
    var found = false;
    var updated = steps.map(function (s) {
        if (s.id !== identifier && s.pathUrl !== identifier)
            return s;
        found = true;
        var prevDetails = isPlainObject(s.details) ? s.details : {};
        var nextDetails = __assign({}, prevDetails);
        for (var _i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
            var item = responses_1[_i];
            var key = extractKeyFromApiName(item.apiName); // ej. "Plan"
            var prevForKey = isPlainObject(nextDetails[key]) || Array.isArray(nextDetails[key])
                ? nextDetails[key]
                : undefined;
            nextDetails[key] =
                prevForKey !== undefined ? deepMerge(prevForKey, item.data) : item.data;
        }
        return __assign(__assign({}, s), { details: nextDetails });
    });
    if (!found) {
        throw new Error("Step no encontrado para: ".concat(identifier));
    }
    localStorage.setItem(storageKey, JSON.stringify(updated));
    return updated;
}
